<script setup>
import WootLabel from 'dashboard/components-next/label/Label.vue';

import { useAutomationOperationsFormatters } from './composables/useAutomationOperationsFormatters';

defineProps({
  timeline: { type: Array, default: () => [] },
});

const { formatDate, formatStatus, labelColor } =
  useAutomationOperationsFormatters();
</script>

<template>
  <div
    class="min-w-0 border-t border-n-weak pt-4 lg:border-l lg:border-t-0 lg:pl-4 lg:pt-0"
  >
    <div class="mb-3 flex items-center justify-between gap-3">
      <span class="text-heading-3 text-n-slate-12">
        {{ $t('AUTOMATION.OPERATIONS.EXECUTION.TIMELINE') }}
      </span>
      <WootLabel :label="timeline.length.toString()" color="slate" compact />
    </div>
    <div v-if="timeline.length" class="max-h-96 overflow-y-auto pr-1">
      <div
        v-for="event in timeline"
        :key="`${event.type}:${event.at}:${event.action_ref || ''}:${event.attempt_id || ''}:${event.receipt_id || ''}`"
        class="grid grid-cols-[8.5rem_minmax(0,1fr)] gap-3 border-b border-n-weak py-2 last:border-b-0"
      >
        <span class="text-body-main tabular-nums text-n-slate-11">
          {{ formatDate(event.at) }}
        </span>
        <div class="min-w-0">
          <div class="flex min-w-0 flex-wrap items-center gap-2">
            <span class="truncate text-body-main text-n-slate-12">
              {{ formatStatus(event.type) }}
            </span>
            <WootLabel
              v-if="event.result"
              :label="formatStatus(event.result)"
              :color="labelColor(event.result)"
              compact
            />
          </div>
          <div
            class="mt-1 flex flex-wrap gap-x-3 gap-y-1 text-body-main text-n-slate-11"
          >
            <span v-if="event.action_ref">{{ event.action_ref }}</span>
            <span v-if="event.summary?.action_name">
              {{ event.summary.action_name }}
            </span>
            <span v-if="event.summary?.provider">
              {{ event.summary.provider }}
            </span>
            <span v-if="event.audit_action">
              {{ event.audit_action }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="py-8 text-center text-body-main text-n-slate-11">
      {{ $t('AUTOMATION.OPERATIONS.EXECUTION.EMPTY_TIMELINE') }}
    </div>
  </div>
</template>
